import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    round: 'Round',
    join: 'Enter for',
    leave: 'Leave',
    starting: 'Starting…',
    youWon: 'You won',
    youTookAll: 'You took it all',
    yourSideWon: 'Your side won',
    playerWon: '{{name}} won',
    howHighest: 'Dropped the most — {{amount}}',
    howLowest: 'Dropped the least — {{amount}}',
    howLastCase: 'Last case drop — {{amount}}',
    howSideHighest: 'Dropped more:',
    howSideLowest: 'Dropped less:',
    versus: 'vs',
    howTied: 'Dropped the same — {{amount}} each',
    tookAllDropped: 'everything dropped, all players',
    eachFromDropped: 'each, out of {{amount}} dropped',
    received: 'Received',
    superDrop: 'Super drop',
    finalRound: 'Decisive round',
    finalRoundHint: 'Only this drop counts',
    sharingTitle: 'Everyone wins',
    teamWon: 'Winning team',
    tie: 'Tie',
    dropped: 'Dropped',
    lastDrop: 'Last drop',
    errorJoining: 'Failed to join the battle',
    errMultiacc: 'You cannot join this battle',
    errorLeaving: 'Failed to leave the battle',
    errorReady: 'Failed to update readiness',
    you: 'You',
    playerFallback: 'Player',
    preparingAnimation: 'Preparing the replay…',
    lobbySlotFree: 'Open',
    lobbyYou: 'You',
    takeSeat: 'Take this seat',
    gathering: 'Gathering players',
    privateTitle: 'Private battle',
    privateHint: 'It is hidden from the list. Send the link to the people you want in.',
    readyBadge: 'ready',
    startNowTitle: 'Start right away',
    readyCount: '{{count}} of {{total}} ready',
    topUpShort: '{{missing}} short — top up',
    addTradeLink: 'Set your trade link',
    joinConfirmTitle: 'Join the battle?',
    chooseSide: 'Which team?',
    sideFull: 'Taken',
    cancel: 'Cancel',
    modeRuleTitle: 'How the winner is decided',
    viewersTitle: 'Who is watching',
    watching: 'Watching: {{count}}',
    viewerPlaying: 'Playing',
    viewerWatching: 'Watching',
    viewersEmpty: 'Nobody yet',
    sellDrops: 'Sell all for',
    sellConfirmTitle: 'Sell all the drops?',
    sellConfirmText: 'The items go straight from your inventory into coins. There is no undo.',
    soldFor: 'Sold. {{amount}} is on your balance',
    sellFailed: 'Could not sell',
    repeatLineup: 'Repeat the battle',
    recreateBattle: 'Recreate the battle',
    recreateLimit: 'Active battles limit reached',
    recreateFailed: 'Could not create the battle',
    replay: 'Watch again',
    toBattles: 'To battles',
    rematchOf: 'This is a rematch — open the first battle',
    cancelledTitle: 'Battle called off',
    cancelledTimeout: 'Nobody joined within 10 minutes',
    cancelledEmpty: 'Everyone left',
    cancelledProcessing: 'The draw failed, entries were returned',
    refunded: 'Your entry of {{amount}} is back on the balance',
    share: 'Share',
    inviteFriend: 'Invite a friend',
    inviteText: 'Jump into my case battle on SHOT — there is a seat for you',
    inviteButton: 'Play',
    linkCopied: 'Link copied',
  },
  ru: {
    round: 'Раунд',
    join: 'Вступить за',
    leave: 'Выйти',
    starting: 'Начинаем…',
    youWon: 'Ты победил',
    youTookAll: 'Ты забрал всё',
    yourSideWon: 'Твоя сторона победила',
    playerWon: 'Победил {{name}}',
    howHighest: 'Выбил больше всех — {{amount}}',
    howLowest: 'Выбил меньше всех — {{amount}}',
    howLastCase: 'Дроп последнего кейса — {{amount}}',
    howSideHighest: 'Выбили больше:',
    howSideLowest: 'Выбили меньше:',
    versus: 'против',
    howTied: 'Выбили поровну — по {{amount}}',
    tookAllDropped: 'всё выбитое всеми игроками',
    eachFromDropped: 'каждому из {{amount}} выбитых',
    received: 'Получил',
    superDrop: 'Супер дроп',
    finalRound: 'Решающий раунд',
    finalRoundHint: 'Считается только этот дроп',
    sharingTitle: 'Делим поровну',
    teamWon: 'Победила команда',
    tie: 'Ничья',
    dropped: 'Выбито',
    lastDrop: 'Последний дроп',
    errorJoining: 'Не удалось присоединиться',
    errMultiacc: 'Ты не можешь участвовать в этом баттле',
    errorLeaving: 'Не удалось выйти',
    errorReady: 'Не удалось отметить готовность',
    you: 'Ты',
    playerFallback: 'Игрок',
    preparingAnimation: 'Готовим показ раунда…',
    lobbySlotFree: 'Свободно',
    lobbyYou: 'Ты',
    takeSeat: 'Сесть сюда',
    gathering: 'Собираем игроков',
    privateTitle: 'Приватный баттл',
    privateHint: 'В списке его нет. Отправь ссылку тем, кого ждёшь.',
    readyBadge: 'готов',
    startNowTitle: 'Стартовать сейчас',
    readyCount: '{{count}} из {{total}} готовы',
    topUpShort: 'Не хватает {{missing}} — пополнить',
    addTradeLink: 'Указать трейд-ссылку',
    joinConfirmTitle: 'Вступить в баттл?',
    chooseSide: 'За какую команду?',
    sideFull: 'Занято',
    cancel: 'Отмена',
    modeRuleTitle: 'Как определяется победитель',
    viewersTitle: 'Кто смотрит',
    watching: 'Смотрят: {{count}}',
    viewerPlaying: 'Играет',
    viewerWatching: 'Смотрит',
    viewersEmpty: 'Пока никого',
    sellDrops: 'Продать все за',
    sellConfirmTitle: 'Продать все дропы?',
    sellConfirmText: 'Предметы уйдут из инвентаря, монеты придут на баланс. Отменить нельзя.',
    soldFor: 'Продано. {{amount}} уже на балансе',
    sellFailed: 'Продать не получилось',
    repeatLineup: 'Повторить баттл',
    recreateBattle: 'Пересоздать баттл',
    recreateLimit: 'Достигнут лимит активных баттлов',
    recreateFailed: 'Не удалось создать баттл',
    replay: 'Пересмотреть',
    toBattles: 'К баттлам',
    rematchOf: 'Это реванш — открыть первый баттл',
    cancelledTitle: 'Баттл отменён',
    cancelledTimeout: 'За 10 минут никто не вступил',
    cancelledEmpty: 'Все участники вышли',
    cancelledProcessing: 'Розыгрыш не удался, входы вернули',
    refunded: 'Твой вход {{amount}} снова на балансе',
    share: 'Поделиться',
    inviteFriend: 'Позвать друга',
    inviteText: 'Залетай в мой кейс-баттл на SHOT — место есть',
    inviteButton: 'Играть',
    linkCopied: 'Ссылка скопирована',
  },
  uz: {
    round: 'Raund',
    join: 'Qoʻshilish',
    leave: 'Chiqish',
    starting: 'Boshlaymiz…',
    youWon: 'Sen yutding',
    youTookAll: 'Hammasini olding',
    yourSideWon: 'Sening tomoning yutdi',
    playerWon: '{{name}} yutdi',
    howHighest: 'Eng koʻp tushirdi — {{amount}}',
    howLowest: 'Eng kam tushirdi — {{amount}}',
    howLastCase: 'Oxirgi keys dropi — {{amount}}',
    howSideHighest: 'Koʻproq tushirdi:',
    howSideLowest: 'Kamroq tushirdi:',
    versus: 'va',
    howTied: 'Teng tushirdi — har biri {{amount}}',
    tookAllDropped: 'barcha oʻyinchilarga tushgan hamma narsa',
    eachFromDropped: 'har biriga, tushgan {{amount}} dan',
    received: 'Oldi',
    superDrop: 'Super drop',
    finalRound: 'Hal qiluvchi raund',
    finalRoundHint: 'Faqat shu drop hisobga olinadi',
    sharingTitle: 'Teng boʻlamiz',
    teamWon: 'Gʻolib jamoa',
    tie: 'Durang',
    dropped: 'Tushdi',
    lastDrop: 'Oxirgi drop',
    errorJoining: 'Qoʻshilib boʻlmadi',
    errMultiacc: 'Sen bu battleda ishtirok eta olmaysan',
    errorLeaving: 'Chiqib boʻlmadi',
    errorReady: 'Tayyorlikni belgilab boʻlmadi',
    you: 'Sen',
    playerFallback: 'Oʻyinchi',
    preparingAnimation: 'Raund koʻrsatuvi tayyorlanmoqda…',
    lobbySlotFree: 'Boʻsh',
    lobbyYou: 'Sen',
    takeSeat: 'Shu joyga oʻtirish',
    gathering: 'Oʻyinchilarni yigʻamiz',
    privateTitle: 'Shaxsiy battle',
    privateHint: 'Roʻyxatda koʻrinmaydi. Havolani kutayotganlaringga yubor.',
    readyBadge: 'tayyor',
    startNowTitle: 'Hoziroq boshlash',
    readyCount: '{{total}} dan {{count}} tayyor',
    topUpShort: '{{missing}} yetmaydi — toʻldirish',
    addTradeLink: 'Trade-havolani koʻrsatish',
    joinConfirmTitle: 'Battlega qoʻshilasanmi?',
    chooseSide: 'Qaysi jamoaga?',
    sideFull: 'Band',
    cancel: 'Bekor qilish',
    modeRuleTitle: 'Gʻolib qanday aniqlanadi',
    viewersTitle: 'Kim tomosha qilyapti',
    watching: 'Tomosha qilmoqda: {{count}}',
    viewerPlaying: 'Oʻynayapti',
    viewerWatching: 'Tomosha qilyapti',
    viewersEmpty: 'Hozircha hech kim',
    sellDrops: 'Hammasini sotish:',
    sellConfirmTitle: 'Barcha droplarni sotasanmi?',
    sellConfirmText: 'Buyumlar inventardan ketadi, tangalar balansga tushadi. Bekor qilib boʻlmaydi.',
    soldFor: 'Sotildi. {{amount}} allaqachon balansda',
    sellFailed: 'Sotib boʻlmadi',
    repeatLineup: 'Jangni takrorlash',
    recreateBattle: 'Jangni qayta yaratish',
    recreateLimit: 'Faol janglar chegarasiga yetildi',
    recreateFailed: 'Jangni yaratib boʻlmadi',
    replay: 'Qayta koʻrish',
    toBattles: 'Battlelarga',
    rematchOf: 'Bu revansh — birinchi battleni ochish',
    cancelledTitle: 'Battle bekor qilindi',
    cancelledTimeout: '10 daqiqada hech kim qoʻshilmadi',
    cancelledEmpty: 'Barcha ishtirokchilar chiqib ketdi',
    cancelledProcessing: 'Oʻyin oʻtmadi, kirishlar qaytarildi',
    refunded: 'Sening {{amount}} kirishing yana balansda',
    share: 'Ulashish',
    inviteFriend: 'Doʻstni chaqirish',
    inviteText: 'SHOTdagi keys-battlimga kir — joy bor',
    inviteButton: 'Oʻynash',
    linkCopied: 'Havola nusxalandi',
  },
  fa: {
    round: 'راند',
    join: 'ورود با',
    leave: 'خروج',
    starting: 'شروع می‌کنیم…',
    youWon: 'تو بردی',
    youTookAll: 'همه را بردی',
    yourSideWon: 'طرف تو برد',
    playerWon: '{{name}} برد',
    howHighest: 'بیشترین دراپ — {{amount}}',
    howLowest: 'کمترین دراپ — {{amount}}',
    howLastCase: 'دراپ کیس آخر — {{amount}}',
    howSideHighest: 'دراپ بیشتر:',
    howSideLowest: 'دراپ کمتر:',
    versus: 'مقابل',
    howTied: 'دراپ برابر — هر نفر {{amount}}',
    tookAllDropped: 'همهٔ دراپ‌های همهٔ بازیکنان',
    eachFromDropped: 'به هر نفر، از {{amount}} دراپ',
    received: 'دریافت کرد',
    superDrop: 'سوپر دراپ',
    finalRound: 'راند تعیین‌کننده',
    finalRoundHint: 'فقط همین دراپ حساب می‌شود',
    sharingTitle: 'مساوی تقسیم می‌کنیم',
    teamWon: 'تیم برنده',
    tie: 'مساوی',
    dropped: 'افتاده',
    lastDrop: 'آخرین دراپ',
    errorJoining: 'پیوستن به بتل نشد',
    errMultiacc: 'نمی‌توانی وارد این بتل شوی',
    errorLeaving: 'خروج نشد',
    errorReady: 'ثبت آمادگی نشد',
    you: 'تو',
    playerFallback: 'بازیکن',
    preparingAnimation: 'در حال آماده‌سازی پخش…',
    lobbySlotFree: 'خالی',
    lobbyYou: 'تو',
    takeSeat: 'اینجا بنشین',
    gathering: 'جمع کردن بازیکن‌ها',
    privateTitle: 'بتل خصوصی',
    privateHint: 'در فهرست دیده نمی‌شود. لینک را برای کسانی که منتظرشان هستی بفرست.',
    readyBadge: 'آماده',
    startNowTitle: 'همین حالا شروع کن',
    readyCount: '{{count}} از {{total}} آماده',
    topUpShort: '{{missing}} کم است — شارژ کن',
    addTradeLink: 'لینک ترید را بگذار',
    joinConfirmTitle: 'وارد بتل می‌شوی؟',
    chooseSide: 'کدام تیم؟',
    sideFull: 'پر است',
    cancel: 'بی‌خیال',
    modeRuleTitle: 'برنده چطور مشخص می‌شود',
    viewersTitle: 'چه کسی تماشا می‌کند',
    watching: 'تماشاگر: {{count}}',
    viewerPlaying: 'بازی می‌کند',
    viewerWatching: 'تماشا می‌کند',
    viewersEmpty: 'هنوز کسی نیست',
    sellDrops: 'فروش همه با',
    sellConfirmTitle: 'همه دراپ‌ها فروخته شود؟',
    sellConfirmText: 'آیتم‌ها از انبار می‌روند و سکه‌ها به موجودی می‌آیند. برگشت ندارد.',
    soldFor: 'فروخته شد. {{amount}} روی موجودی است',
    sellFailed: 'فروش نشد',
    repeatLineup: 'تکرار نبرد',
    recreateBattle: 'ساخت دوباره نبرد',
    recreateLimit: 'به سقف نبردهای فعال رسیدی',
    recreateFailed: 'ساخت نبرد انجام نشد',
    replay: 'تماشای دوباره',
    toBattles: 'به بتل‌ها',
    rematchOf: 'این بازی مجدد است — باز کردن بتل اول',
    cancelledTitle: 'بتل لغو شد',
    cancelledTimeout: 'در 10 دقیقه کسی نیامد',
    cancelledEmpty: 'همه شرکت‌کننده‌ها رفتند',
    cancelledProcessing: 'قرعه انجام نشد، ورودی‌ها برگشت',
    refunded: 'ورودی {{amount}} تو دوباره روی موجودی است',
    share: 'اشتراک',
    inviteFriend: 'دعوت دوست',
    inviteText: 'بپر توی کیس‌بتل من در SHOT — جا هست',
    inviteButton: 'بازی',
    linkCopied: 'لینک کپی شد',
  },
  pt: {
    round: 'Rodada',
    join: 'Entrar por',
    leave: 'Sair',
    starting: 'Começando…',
    youWon: 'Você venceu',
    youTookAll: 'Você levou tudo',
    yourSideWon: 'Seu lado venceu',
    playerWon: '{{name}} venceu',
    howHighest: 'Tirou o maior drop — {{amount}}',
    howLowest: 'Tirou o menor drop — {{amount}}',
    howLastCase: 'Drop da última caixa — {{amount}}',
    howSideHighest: 'Tiraram mais:',
    howSideLowest: 'Tiraram menos:',
    versus: 'contra',
    howTied: 'Tiraram o mesmo — {{amount}} cada',
    tookAllDropped: 'tudo que caiu para todos os jogadores',
    eachFromDropped: 'cada um, de {{amount}} que caíram',
    received: 'Recebeu',
    superDrop: 'Super drop',
    finalRound: 'Rodada decisiva',
    finalRoundHint: 'Só este drop conta',
    sharingTitle: 'Dividimos igual',
    teamWon: 'Time vencedor',
    tie: 'Empate',
    dropped: 'Caiu',
    lastDrop: 'Último drop',
    errorJoining: 'Não foi possível entrar na batalha',
    errMultiacc: 'Você não pode participar desta batalha',
    errorLeaving: 'Não foi possível sair da batalha',
    errorReady: 'Não foi possível marcar como pronto',
    you: 'Você',
    playerFallback: 'Jogador',
    preparingAnimation: 'Preparando o replay…',
    lobbySlotFree: 'Livre',
    lobbyYou: 'Você',
    takeSeat: 'Sentar aqui',
    gathering: 'Reunindo jogadores',
    privateTitle: 'Batalha privada',
    privateHint: 'Ela não aparece na lista. Mande o link para quem você quer dentro.',
    readyBadge: 'pronto',
    startNowTitle: 'Começar agora',
    readyCount: '{{count}} de {{total}} prontos',
    topUpShort: 'Faltam {{missing}} — depositar',
    addTradeLink: 'Informar o link de troca',
    joinConfirmTitle: 'Entrar na batalha?',
    chooseSide: 'Qual time?',
    sideFull: 'Ocupado',
    cancel: 'Cancelar',
    modeRuleTitle: 'Como o vencedor é definido',
    viewersTitle: 'Quem está assistindo',
    watching: 'Assistindo: {{count}}',
    viewerPlaying: 'Jogando',
    viewerWatching: 'Assistindo',
    viewersEmpty: 'Ninguém ainda',
    sellDrops: 'Vender tudo por',
    sellConfirmTitle: 'Vender todos os drops?',
    sellConfirmText: 'Os itens saem do inventário e as moedas vão para o saldo. Não dá para desfazer.',
    soldFor: 'Vendido. {{amount}} já está no seu saldo',
    sellFailed: 'Não foi possível vender',
    repeatLineup: 'Repetir a batalha',
    recreateBattle: 'Recriar a batalha',
    recreateLimit: 'Limite de batalhas ativas atingido',
    recreateFailed: 'Não foi possível criar a batalha',
    replay: 'Ver de novo',
    toBattles: 'Para as batalhas',
    rematchOf: 'Isto é uma revanche — abrir a primeira batalha',
    cancelledTitle: 'Batalha cancelada',
    cancelledTimeout: 'Ninguém entrou em 10 minutos',
    cancelledEmpty: 'Todos saíram',
    cancelledProcessing: 'O sorteio falhou, as entradas foram devolvidas',
    refunded: 'Sua entrada de {{amount}} voltou para o saldo',
    share: 'Compartilhar',
    inviteFriend: 'Chamar um amigo',
    inviteText: 'Entra na minha batalha de caixas no SHOT — tem vaga para você',
    inviteButton: 'Jogar',
    linkCopied: 'Link copiado',
  },
  tr: {
    round: 'Raund',
    join: 'Katıl:',
    leave: 'Ayrıl',
    starting: 'Başlıyor…',
    youWon: 'Kazandın',
    youTookAll: 'Hepsini aldın',
    yourSideWon: 'Senin tarafın kazandı',
    playerWon: '{{name}} kazandı',
    howHighest: 'En çok düşüren — {{amount}}',
    howLowest: 'En az düşüren — {{amount}}',
    howLastCase: 'Son kasanın dropu — {{amount}}',
    howSideHighest: 'Daha çok düşürdü:',
    howSideLowest: 'Daha az düşürdü:',
    versus: 'vs',
    howTied: 'Eşit düşürdüler — {{amount}} her biri',
    tookAllDropped: 'tüm oyuncuların düşürdüğü her şey',
    eachFromDropped: 'her biri, düşen {{amount}} içinden',
    received: 'Aldı',
    superDrop: 'Süper drop',
    finalRound: 'Belirleyici raund',
    finalRoundHint: 'Sadece bu drop sayılır',
    sharingTitle: 'Eşit paylaşım',
    teamWon: 'Kazanan takım',
    tie: 'Berabere',
    dropped: 'Düşen',
    lastDrop: 'Son drop',
    errorJoining: 'Savaşa katılınamadı',
    errMultiacc: 'Bu savaşa katılamazsın',
    errorLeaving: 'Savaştan ayrılınamadı',
    errorReady: 'Hazır durumu güncellenemedi',
    you: 'Sen',
    playerFallback: 'Oyuncu',
    preparingAnimation: 'Tekrar hazırlanıyor…',
    lobbySlotFree: 'Boş',
    lobbyYou: 'Sen',
    takeSeat: 'Buraya otur',
    gathering: 'Oyuncular toplanıyor',
    privateTitle: 'Özel savaş',
    privateHint: 'Listede görünmez. Linki beklediğin kişilere gönder.',
    readyBadge: 'hazır',
    startNowTitle: 'Hemen başlat',
    readyCount: '{{total}} kişiden {{count}} hazır',
    topUpShort: '{{missing}} eksik — yatır',
    addTradeLink: 'Takas linkini gir',
    joinConfirmTitle: 'Savaşa katılıyor musun?',
    chooseSide: 'Hangi takım?',
    sideFull: 'Dolu',
    cancel: 'İptal',
    modeRuleTitle: 'Kazanan nasıl belirlenir',
    viewersTitle: 'Kim izliyor',
    watching: 'İzleyen: {{count}}',
    viewerPlaying: 'Oynuyor',
    viewerWatching: 'İzliyor',
    viewersEmpty: 'Henüz kimse yok',
    sellDrops: 'Hepsini sat:',
    sellConfirmTitle: 'Tüm droplar satılsın mı?',
    sellConfirmText: 'Eşyalar envanterden çıkar, coinler bakiyene gelir. Geri alınamaz.',
    soldFor: 'Satıldı. {{amount}} bakiyende',
    sellFailed: 'Satılamadı',
    repeatLineup: 'Savaşı tekrarla',
    recreateBattle: 'Savaşı yeniden oluştur',
    recreateLimit: 'Aktif savaş sınırına ulaşıldı',
    recreateFailed: 'Savaş oluşturulamadı',
    replay: 'Tekrar izle',
    toBattles: 'Savaşlara',
    rematchOf: 'Bu bir rövanş — ilk savaşı aç',
    cancelledTitle: 'Savaş iptal edildi',
    cancelledTimeout: '10 dakika içinde kimse katılmadı',
    cancelledEmpty: 'Herkes ayrıldı',
    cancelledProcessing: 'Çekiliş başarısız oldu, girişler iade edildi',
    refunded: '{{amount}} girişin bakiyene geri döndü',
    share: 'Paylaş',
    inviteFriend: 'Arkadaş çağır',
    inviteText: "SHOT'taki kasa savaşıma gel — senin için yer var",
    inviteButton: 'Oyna',
    linkCopied: 'Link kopyalandı',
  },
});
